import React, { useState, useRef } from "react";
import "./Mid-Section.scss";

import ViewPaymentsSelectCard from "./ViewPaymentsSelectCard";
import RecentPaymentsCards from "../../OverView/Mobile-and-Tablet/RecentPaymentsCards";

// Import images from the assets folder
import imageSource1 from "../../../assets/images/abstract-4.png";
import imageSource2 from "../../../assets/images/abstract-5.png";
import PendingIncoicesCard from "./PendingIncoicesCard";
import PayWindowModal from "./PayWindowModal";

const MidSectionPayments = () => {
  //payment popup
  const [showPay, setShowPay] = useState(false);

  //index of select cards
  const [currentIndex, setCurrentIndex] = useState(0);
  const sliderRef = useRef(null);

  const cardWidth = 162; // Width of each card in pixels
  const gapWidth = 10; // Gap between cards in pixels

  const moveToCard = (index) => {
    setCurrentIndex(index);
    const totalScrollLeft = index * (cardWidth + gapWidth);
    sliderRef.current.scrollLeft = totalScrollLeft;
  };

  return (
    <div className="mid-section-payments">
      <div style={{ display: "flex", justifyContent: "space-between",alignItems: "center",padding:"0px 15px 0px 0px"}}>
        <div className="title">View select</div>
        <div className="make-payment-button" onClick={() => {
          setShowPay(true);
          
        }}>Make Payment</div>
      </div>

      <div className="view-payment-select-container">
        <div className="slider-container" ref={sliderRef}>
          <div className="slider">
            {[
              {
                Title: "View unpaid invoices",
                Ammount: "5",
                SubText: "Invoices Pending",
                imageLink: imageSource2,
                colorOfIcon: "192A3A",
                setBackgroundSizeAndPosition: ["500% 110%", "center left"],
              },
              {
                Title: "View All Payments",
                Ammount: "ksh.10,000",
                SubText: "Payments Made",
                imageLink: imageSource1,
                colorOfIcon: "192A3A",
                setBackgroundSizeAndPosition: ["auto", "left top"],
              },
              {
                Title: "Pending Payments",
                Ammount: "ksh10,000",
                SubText: "Awaiting Approval",
                imageLink: imageSource2,
                colorOfIcon: "192A3A",
                setBackgroundSizeAndPosition: ["500% 110%", "center left"],
              },
            ].map((card, index) => (
              <button
                key={index}
                className="payment-card-button"
                onClick={() => moveToCard(index)}
              >
                <ViewPaymentsSelectCard
                  Title={card.Title}
                  Ammount={card.Ammount}
                  SubText={card.SubText}
                  imageLink={card.imageLink}
                  colorOfIcon={card.colorOfIcon}
                  setBackgroundSizeAndPosition={
                    card.setBackgroundSizeAndPosition
                  }
                  icon={card.icon}
                />
              </button>
            ))}
          </div>
        </div>
      </div>

      {currentIndex === 0 && (
        <>
          <div className="recentPayments">
            <div className="title recent-payments">Pending Invoices</div>
            <PendingIncoicesCard setShowPay={setShowPay} />
          </div>
        </>
      )}

      {currentIndex === 1 && (
        <>
          <div className="recentPayments">
            <div className="title recent-payments">Recent payments</div>
            <RecentPaymentsCards />
          </div>
        </>
      )}

      {currentIndex === 2 && (
        <>
          <div className="recentPayments">
            <div className="title recent-payments">
              Payments awaiting approval
            </div>
            <RecentPaymentsCards awaitingApproval={true} />
          </div>
        </>
      )}

      {showPay && (
        <>
          <div className="modal">
            <PayWindowModal setShowPay={setShowPay} fieldToShow={false} />
          </div>
        </>
      )}
    </div>
  );
};

export default MidSectionPayments;
